import React, { useState } from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';
import { Link } from 'react-router-dom';

const Department = () => {
  const [isActive, setIsActive] = useState(0);

  return (
    <section id="department">
      <div className="st-height-b120 st-height-lg-b80" />
      <SectionHeading title='Nuestros servicios'
        subTitle = 
        "Contamos con servicios médicos especializados y una atención enfocada en el bienestar de nuestros pacientes. <br />Nuestro compromiso es brindar soluciones oportunas, seguras y humanizadas en un entorno accesible." />
      <div className="container">
        <div className="st-tabs st-fade-tabs st-style1">
          <ul className="st-tab-links st-style1 st-mp0">
            <li className={`st-tab-title ${isActive === 0 ? "active" : ""}`} onClick={() => setIsActive(0)}>
              <span className="st-blue-box">
                <svg
                  enableBackground="new 0 0 512 512"
                  viewBox="0 0 512 512"
                  width="800px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
                    <path d="M3855 5104 c-345 -77 -636 -322 -763 -644 -59 -151 -67 -198 -66
                    -405 0 -178 2 -196 27 -280 111 -364 369 -622 732 -732 85 -25 101 -27 285
                    -27 183 0 201 2 285 27 360 108 624 372 731 732 36 121 45 358 19 486 -45 224
                    -139 401 -296 558 -127 126 -276 213 -456 267 -77 23 -110 27 -258 30 -128 3
                    -187 0 -240 -12z m380 -311 c247 -55 456 -247 541 -498 36 -104 45 -292 20
                    -399 -35 -150 -131 -304 -254 -409 -70 -60 -213 -131 -306 -152 -89 -21 -243
                    -21 -332 0 -148 34 -301 130 -409 255 -58 68 -129 212 -151 305 -25 108 -16
                    295 20 400 127 372 495 583 871 498z"/>
                    <path d="M3986 4491 c-55 -37 -66 -66 -66 -178 l0 -103 -102 0 c-84 0 -108 -4
                    -132 -19 -46 -31 -66 -69 -66 -131 0 -62 20 -100 66 -131 24 -15 48 -19 132
                    -19 l102 0 0 -102 c0 -113 11 -142 66 -179 39 -26 129 -26 168 0 55 37 66 66
                    66 179 l0 102 103 0 c112 0 141 11 178 66 26 39 26 129 0 168 -37 55 -66 66
                    -178 66 l-103 0 0 103 c0 83 -4 107 -19 131 -31 46 -69 66 -131 66 -37 0 -64
                    -6 -84 -19z"/>
                    <path d="M666 4491 c-55 -37 -66 -66 -66 -178 l0 -103 -252 0 c-279 0 -286 -2
                    -329 -66 -18 -28 -19 -57 -19 -579 0 -610 3 -644 65 -832 67 -200 175 -373
                    330 -528 136 -136 319 -256 475 -310 l35 -12 5 -174 c5 -173 5 -174 39 -244
                    42 -86 124 -171 203 -209 l57 -28 3 -321 c4 -320 4 -322 31 -396 46 -126 93
                    -199 191 -296 104 -104 205 -161 340 -195 76 -19 114 -20 941 -20 976 0 934
                    -3 1105 82 69 34 103 60 180 138 78 77 104 111 138 180 74 149 82 200 82 530
                    l0 288 82 26 c120 37 200 88 303 191 72 72 99 107 133 175 58 117 82 218 82
                    347 0 135 -21 225 -78 343 -39 82 -59 108 -141 190 -78 78 -112 104 -181 138
                    -117 58 -218 82 -347 82 -134 0 -225 -20 -343 -77 -82 -40 -108 -59 -191 -142
                    -83 -83 -102 -109 -142 -191 -60 -125 -77 -201 -77 -337 0 -136 23 -234 82
                    -353 34 -68 61 -103 133 -175 103 -103 183 -154 302 -191 l83 -26 0 -222 c0
                    -121 -5 -255 -10 -295 -27 -206 -185 -364 -391 -391 -97 -12 -1511 -12 -1608
                    0 -206 27 -364 185 -391 391 -5 40 -10 176 -10 300 l0 227 58 28 c79 38 161
                    123 203 209 34 70 34 71 39 243 l5 173 82 33 c45 19 120 57 167 85 335 203
                    562 526 636 906 19 99 20 143 20 658 0 524 -1 553 -19 581 -43 64 -50 66 -333
                    66 l-258 0 0 103 c0 83 -4 107 -19 131 -31 46 -69 66 -131 66 -62 0 -100 -20
                    -131 -66 -18 -27 -19 -53 -19 -384 0 -331 1 -357 19 -384 31 -46 69 -66 131
                    -66 62 0 100 20 131 66 15 24 19 48 19 132 l0 102 155 0 155 0 0 -352 c0 -411
                    -10 -549 -45 -673 -69 -242 -222 -452 -428 -589 -598 -398 -1404 -101 -1602
                    589 -35 124 -45 262 -45 673 l0 352 150 0 150 0 0 -102 c0 -84 4 -108 19 -132
                    31 -46 69 -66 131 -66 62 0 100 20 131 66 18 27 19 53 19 384 0 331 -1 357
                    -19 384 -31 46 -69 66 -131 66 -37 0 -64 -6 -84 -19z m3587 -2128 c90 -43 177
                    -129 220 -220 30 -64 32 -74 32 -183 0 -109 -2 -119 -32 -183 -21 -44 -53 -89
                    -92 -128 -39 -39 -84 -71 -128 -92 -64 -30 -74 -32 -183 -32 -109 0 -119 2
                    -183 32 -91 43 -177 129 -220 220 -30 64 -32 74 -32 183 0 109 2 119 32 183
                    37 78 125 172 193 207 81 42 120 50 225 47 89 -2 108 -6 168 -34z m-2745 -647
                    c-4 -72 -10 -102 -26 -127 -57 -93 -187 -93 -244 0 -16 25 -22 55 -26 127 l-5
                    94 153 0 153 0 -5 -94z"/>
                    <path d="M3986 2091 c-46 -31 -66 -69 -66 -131 0 -95 55 -150 150 -150 95 0
                    150 55 150 150 0 95 -55 150 -150 150 -37 0 -64 -6 -84 -19z"/>
                  </g>
                </svg>
                <span>Consultas</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 1 ? "active" : ""}`} onClick={() => setIsActive(1)}>
              <span className="st-red-box">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 480 480"
                  xmlSpace="preserve"
                >
                  <g>
                    <path
                      d="M440,128H40c-4.418,0-8,3.582-8,8v208c0,4.418,3.582,8,8,8h52.52c6.941,39.326,3.217,79.793-10.784,117.192
              c-1.551,4.137,0.546,8.748,4.683,10.299c0.897,0.336,1.847,0.509,2.805,0.509h301.552c4.418-0.002,7.999-3.585,7.997-8.003
              c0-0.958-0.173-1.908-0.509-2.805C384.263,431.793,380.539,391.326,387.48,352H440c4.418,0,8-3.582,8-8V136
              C448,131.582,444.418,128,440,128z M100.48,464c11.614-36.146,14.466-74.535,8.32-112h262.4c-6.146,37.465-3.294,75.854,8.32,112
              H100.48z M432,336h-41.384l24-110.304l-15.64-3.392L374.24,336H105.76L81.048,222.304l-15.64,3.392l24,110.304H48V144h184v51.72
              l-8,5.336v-32.912c0-4.418-3.582-8-8-8c-22.624-0.066-44.333,8.928-60.28,24.976c-28.091,27.923-43.835,65.928-43.72,105.536
              c-0.066,11.388,6.531,21.764,16.872,26.536c3.914,1.843,8.186,2.802,12.512,2.808c6.839-0.015,13.455-2.437,18.688-6.84
              l6.096-5.072c3.057-2.553,6.913-3.952,10.896-3.952h13.912c18.223-0.022,32.993-14.785,33.024-33.008V220.28l16-10.68l16,10.664
              v50.696c0.013,18.236,14.788,33.018,33.024,33.04h13.912c3.981,0.001,7.836,1.397,10.896,3.944l6.096,5.072
              c5.236,4.404,11.854,6.826,18.696,6.84c4.32-0.007,8.586-0.963,12.496-2.8c10.345-4.777,16.945-15.158,16.88-26.552
              c0.109-39.606-15.635-77.609-43.72-105.536C308.329,168.927,286.622,159.936,264,160c-4.418,0-8,3.582-8,8v33.056l-8-5.336V144
              h184V336z M208,176.592v94.536c-0.018,9.393-7.63,17.003-17.024,17.016h-13.912c-7.729,0.003-15.212,2.711-21.152,7.656
              l-6.088,5.072c-5.643,4.706-14.032,3.945-18.738-1.698c-1.994-2.391-3.086-5.405-3.086-8.518
              c-0.102-35.362,13.954-69.293,39.032-94.224C178.034,185.352,192.485,178.354,208,176.592z M272,270.976v-94.52
              c15.512,1.761,29.961,8.753,40.968,19.824c25.074,24.934,39.129,58.863,39.032,94.224c0.003,7.348-5.95,13.307-13.298,13.31
              c-3.116,0.001-6.133-1.091-8.526-3.086l-6.096-5.08c-5.942-4.935-13.42-7.64-21.144-7.648h-13.912
              C279.626,287.991,272.009,280.374,272,270.976z"
                    />
                  </g>
                  <g>
                    <path
                      d="M405.712,56H304V8c0-4.418-3.582-8-8-8H184c-4.418,0-8,3.582-8,8v48H74.288C33.285,56.062,0.062,89.285,0,130.288V168h16
              v-37.712C16.062,98.122,42.122,72.062,74.288,72H184c4.418,0,8-3.582,8-8V16h96v48c0,4.418,3.582,8,8,8h109.712
              c32.166,0.062,58.226,26.122,58.288,58.288V168h16v-37.712C479.938,89.285,446.715,56.062,405.712,56z"
                    />
                  </g>
                  <g>
                    <polygon points="186.344,218.344 172.688,232 152,232 152,248 168,248 168,264 184,264 184,243.312 197.656,229.656    " />
                  </g>
                  <g>
                    <polygon points="307.312,232 293.656,218.344 282.344,229.656 296,243.312 296,264 312,264 312,248 328,248 328,232    " />
                  </g>
                </svg>
                <span>Imágenes</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 2 ? "active" : ""}`} onClick={() => setIsActive(2)}>
              <span className="st-green-box">
                <svg
                  enableBackground="new 0 0 512 512"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
                    <path d="M3115 5051 l-190 -70 -65 32 -65 32 -389 3 c-215 2 -405 1 -424 -3
                    -18 -3 -42 -15 -53 -26 -23 -23 -25 -77 -5 -105 14 -18 33 -19 428 -24 464 -6
                    454 -4 505 -81 37 -56 38 -121 1 -176 -51 -78 14 -73 -1006 -73 l-909 0 -34
                    23 c-98 66 -106 194 -16 268 42 34 99 39 446 39 l340 0 20 26 c28 35 26 67 -3
                    101 l-24 28 -374 0 c-364 0 -374 -1 -429 -23 -67 -27 -138 -94 -171 -160 -16
                    -33 -24 -70 -26 -124 -6 -112 15 -167 93 -245 34 -34 74 -65 88 -68 l27 -7 2
                    -902 3 -901 23 -47 c19 -39 61 -79 218 -209 l194 -162 0 -139 0 -138 -26 0
                    c-38 0 -61 -16 -73 -50 -19 -55 16 -109 72 -110 l27 0 0 -157 c0 -183 10 -216
                    79 -275 50 -42 114 -63 176 -56 l45 6 0 -384 0 -384 -44 -43 c-53 -51 -59 -80
                    -54 -250 3 -128 12 -150 78 -195 32 -21 41 -22 259 -22 223 0 227 0 262 24 59
                    40 69 74 69 231 0 156 -11 192 -66 228 l-34 22 0 385 0 385 73 0 c61 0 79 4
                    119 28 94 55 118 120 118 319 l0 138 25 0 c36 0 75 42 75 80 0 38 -39 80 -75
                    80 l-25 0 0 120 0 120 38 -24 c20 -13 134 -59 252 -101 118 -42 220 -82 227
                    -88 6 -7 32 -67 56 -134 l44 -123 -33 -19 c-30 -18 -34 -25 -34 -64 0 -57 24
                    -80 83 -79 l43 1 49 -135 c54 -146 84 -192 148 -226 55 -29 146 -30 205 -4 23
                    11 44 17 46 15 2 -2 63 -165 135 -363 l130 -358 -21 -28 c-37 -51 -35 -111 10
                    -232 46 -126 62 -152 105 -178 57 -35 114 -27 313 46 98 36 190 75 202 87 65
                    60 67 124 12 273 -48 133 -63 154 -127 179 l-50 20 -129 354 c-71 194 -130
                    357 -132 362 -2 5 17 14 42 20 69 17 123 61 152 122 36 79 32 125 -26 284 -28
                    76 -46 139 -41 141 64 21 83 103 34 142 -21 16 -37 21 -64 17 l-37 -5 -46 130
                    -47 129 121 209 c67 115 126 226 132 247 5 20 8 56 4 79 -3 23 -53 173 -112
                    335 -108 298 -129 339 -174 339 -34 0 -68 -22 -81 -51 -11 -27 -2 -56 101
                    -338 109 -301 112 -310 97 -340 -8 -17 -70 -124 -136 -239 -67 -115 -121 -218
                    -121 -230 0 -12 59 -181 130 -377 72 -196 130 -365 130 -375 0 -56 -85 -86
                    -120 -43 -26 33 -302 801 -295 822 3 11 64 120 135 242 72 123 130 232 130
                    243 0 14 -505 1415 -565 1567 -5 14 7 21 60 39 36 12 68 20 69 19 2 -2 63
                    -168 136 -369 83 -231 139 -371 152 -382 48 -42 128 -7 128 55 0 18 -60 199
                    -134 402 l-135 369 31 35 c85 96 108 241 57 351 -34 74 -76 120 -141 155 -45
                    25 -66 30 -143 32 -90 3 -91 3 -280 -66z m381 -137 c65 -66 65 -162 1 -227
                    -26 -25 -73 -47 -223 -101 -104 -38 -224 -81 -268 -97 l-78 -29 32 37 c72 81
                    100 194 77 309 l-8 41 158 56 c87 31 167 58 178 59 38 7 98 -15 131 -48z
                    m-2306 -1358 l0 -845 23 -24 c12 -13 106 -94 208 -180 103 -86 189 -163 193
                    -172 3 -9 6 -205 6 -436 l0 -420 -25 -24 c-30 -30 -54 -31 -89 -4 l-26 20 0
                    392 c-1 289 -4 398 -13 413 -7 12 -100 95 -207 184 -107 89 -200 172 -207 184
                    -9 16 -12 227 -13 889 l0 867 75 0 75 0 0 -844z m273 792 c-38 -73 -39 -197
                    -4 -276 44 -97 140 -166 263 -188 33 -5 39 -11 54 -53 10 -25 23 -61 31 -80 7
                    -18 13 -37 13 -42 0 -5 -106 -9 -235 -9 l-235 0 0 350 0 350 70 0 70 0 -27
                    -52z m905 -20 l-3 -73 -225 -82 c-381 -140 -374 -138 -423 -123 -55 16 -113
                    75 -122 124 -17 88 36 164 141 203 55 20 77 22 347 22 l288 1 -3 -72z m302
                    -801 c0 -686 -3 -877 -13 -890 -7 -10 -102 -93 -212 -185 l-200 -167 -5 -400
                    c-3 -220 -9 -407 -13 -416 -12 -25 -53 -42 -81 -35 -54 13 -56 29 -56 468 0
                    222 3 413 6 426 4 13 92 94 211 193 112 94 208 181 213 195 6 15 10 354 10
                    855 l0 829 70 0 70 0 0 -873z m508 791 c132 -358 213 -591 206 -597 -8 -7
                    -538 -201 -549 -201 -3 0 -4 165 -3 367 l3 366 155 58 c85 32 158 58 162 58 4
                    1 15 -23 26 -51z m-808 -429 l0 -190 -26 3 c-24 3 -31 15 -80 152 -30 82 -54
                    154 -54 161 0 11 114 61 148 64 9 1 12 -43 12 -190z m-270 -58 l48 -131 -77 0
                    -76 0 -34 96 c-18 52 -34 102 -35 110 -1 10 20 24 59 39 33 12 62 21 63 20 2
                    -2 25 -62 52 -134z m1401 -399 c25 -70 46 -128 45 -128 -1 -1 -149 -56 -331
                    -122 -181 -66 -342 -125 -357 -131 l-28 -11 0 153 0 152 308 111 c169 62 309
                    110 312 107 2 -2 25 -61 51 -131z m-1131 -32 l0 -140 -510 0 -510 0 0 140 0
                    140 510 0 510 0 0 -140z m1289 -404 l51 -140 -121 -208 c-66 -115 -125 -225
                    -131 -246 -10 -35 -6 -109 6 -142 5 -11 -11 -22 -63 -41 l-70 -26 -12 30 c-19
                    44 -66 95 -108 116 -20 10 -129 51 -242 91 l-207 74 23 31 c35 48 39 63 44
                    203 l6 134 380 138 c209 76 383 135 387 132 4 -4 29 -70 57 -146z m-1537 -111
                    c42 -115 77 -217 77 -226 1 -9 -48 -57 -109 -108 -117 -97 -143 -134 -155
                    -214 l-7 -47 -74 0 -74 0 0 28 c0 46 -19 100 -47 133 -15 17 -107 99 -205 181
                    l-178 149 0 159 0 160 347 -2 348 -3 77 -210z m248 56 c0 -128 -3 -161 -15
                    -171 -12 -10 -16 -8 -23 11 -42 112 -112 307 -112 312 0 4 34 7 75 7 l75 0 0
                    -159z m550 -666 c118 -42 222 -84 232 -93 18 -18 298 -780 298 -811 0 -27 -30
                    -59 -62 -67 -50 -11 -65 19 -202 396 -70 195 -135 362 -144 371 -10 9 -120 54
                    -247 99 -247 88 -288 106 -283 121 2 5 27 29 57 53 l53 44 42 -18 c22 -10 138
                    -53 256 -95z m-990 -955 l0 -810 -75 0 -75 0 0 810 0 810 75 0 75 0 0 -810z
                    m1865 33 c148 -405 270 -746 273 -758 3 -18 -6 -24 -63 -44 -36 -13 -67 -22
                    -69 -20 -2 2 -126 341 -275 753 -159 434 -269 752 -264 757 8 8 107 46 124 48
                    3 1 127 -331 274 -736z m465 -984 c18 -49 30 -92 28 -94 -6 -6 -307 -115 -317
                    -115 -7 0 -66 154 -66 174 0 7 286 120 316 125 4 1 21 -40 39 -90z m-2232
                    -116 l-3 -98 -170 0 -170 0 -3 98 -3 97 176 0 176 0 -3 -97z"/>
                  </g>
                </svg>
                <span>Rehabilitación</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 3 ? "active" : ""}`} onClick={() => setIsActive(3)}>
              <span className="st-dip-blue-box">
                <svg
                  width="512.000000pt" 
                  height="512.000000pt" 
                  viewBox="0 0 512.000000 512.000000"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
                      <path d="M2505 4957 c-22 -8 -51 -19 -64 -27 -46 -24 -123 -104 -149 -155 -24
                      -44 -27 -61 -27 -147 l0 -98 -862 -497 c-684 -395 -865 -503 -873 -524 -13
                      -30 -1 -57 87 -204 66 -110 73 -110 244 -11 l129 75 0 -694 0 -695 -27 -1
                      c-16 0 -103 -6 -196 -12 l-167 -12 0 98 c0 146 19 137 -303 137 -243 0 -265
                      -1 -280 -18 -16 -17 -17 -86 -17 -790 0 -687 2 -772 16 -786 13 -14 53 -16
                      283 -16 324 0 301 -10 301 137 l0 100 207 6 208 5 130 -78 c72 -42 302 -181
                      513 -308 434 -262 474 -280 647 -289 70 -4 122 -1 175 10 73 15 1554 589 1610
                      624 14 9 36 26 50 39 25 23 30 24 260 26 l234 3 13 25 c10 20 13 284 13 1257
                      l0 1231 128 -74 c144 -84 179 -91 210 -46 10 15 42 68 70 118 49 86 62 133 44
                      160 -4 6 -394 235 -867 508 l-860 496 0 92 c0 81 -3 100 -28 149 -32 67 -109
                      142 -175 172 -37 17 -66 22 -137 22 -82 0 -97 -3 -155 -32 l-65 -32 -63 31
                      c-51 25 -79 32 -140 35 -46 2 -93 -3 -117 -10z m166 -128 c19 -7 54 -27 78
                      -45 63 -48 84 -48 151 1 111 80 217 72 302 -23 101 -112 65 -241 -124 -438
                      -46 -48 -121 -119 -168 -159 l-86 -73 -64 55 c-294 249 -412 436 -355 558 49
                      102 166 157 266 124z m-315 -459 c15 -22 25 -42 23 -44 -2 -2 -374 -218 -826
                      -479 l-823 -475 -24 45 -25 44 42 25 c140 84 1593 922 1599 923 4 1 20 -17 34
                      -39z m1245 -118 c151 -87 510 -295 799 -461 289 -167 535 -309 547 -317 l22
                      -14 -25 -44 -25 -44 -821 474 c-452 261 -824 477 -827 479 -4 4 46 85 53 85 1
                      0 126 -71 277 -158z m-926 -208 c105 -90 125 -104 151 -104 25 0 157 105 279
                      220 l70 67 677 -391 677 -391 1 -1237 0 -1238 -149 0 -148 0 -5 83 c-5 98 -26
                      144 -91 205 -64 58 -108 75 -197 75 -71 0 -87 -4 -285 -83 -115 -45 -216 -85
                      -222 -87 -10 -4 -13 109 -13 544 0 480 -2 551 -16 571 l-15 22 -561 0 c-508 0
                      -563 -2 -580 -17 -17 -15 -18 -42 -18 -435 l0 -419 -22 7 c-36 11 -42 16 -101
                      85 -236 279 -525 426 -894 455 l-93 7 0 731 1 731 677 391 677 391 65 -61 c36
                      -35 97 -89 135 -122z m615 -2406 l0 -533 -176 -68 c-96 -38 -177 -67 -178 -65
                      -1 1 -10 24 -19 49 -41 110 -80 139 -338 252 l-214 93 -3 402 -2 402 465 0
                      465 0 0 -532z m-2820 -253 l0 -675 -170 0 -170 0 0 675 0 675 170 0 170 0 0
                      -675z m890 440 c268 -54 478 -189 690 -442 32 -37 62 -53 340 -173 168 -72
                      320 -141 338 -152 36 -22 72 -83 72 -122 0 -36 -32 -49 -115 -49 -120 1 -300
                      57 -720 223 -125 49 -239 90 -253 90 -51 0 -81 -61 -49 -103 12 -16 417 -179
                      626 -251 281 -98 456 -115 574 -54 22 11 264 108 536 216 548 216 555 218 629
                      170 95 -64 96 -201 2 -269 -32 -24 -1479 -593 -1559 -614 -111 -28 -266 -13
                      -364 36 -23 12 -267 157 -542 322 l-499 301 -233 -3 -233 -3 0 436 c0 240 1
                      437 3 437 1 1 74 8 162 15 194 15 491 10 595 -11z"/>
                      <path d="M2656 3718 c-13 -18 -16 -54 -16 -185 l0 -163 -169 0 c-213 0 -201
                      10 -201 -178 0 -128 1 -134 25 -157 24 -24 28 -25 185 -25 l160 0 0 -159 c0
                      -218 -6 -211 181 -211 135 0 141 1 164 25 24 24 25 28 25 185 l0 160 159 0
                      c216 0 206 -9 206 183 0 107 -3 148 -14 160 -11 15 -37 17 -182 17 l-168 0 -3
                      168 c-2 125 -7 173 -17 185 -11 15 -36 17 -167 17 -147 0 -153 -1 -168 -22z
                      m224 -277 c0 -144 2 -171 17 -182 12 -10 60 -15 185 -17 l168 -3 0 -50 0 -49
                      -169 0 c-141 0 -172 -3 -185 -16 -13 -13 -16 -44 -16 -185 l0 -169 -55 0 -55
                      0 0 167 c0 141 -3 169 -17 185 -14 16 -34 18 -185 18 l-168 0 0 49 0 50 168 3
                      c125 2 173 7 185 17 15 11 17 38 17 182 l0 169 55 0 55 0 0 -169z"/>
                    </g>
                  </svg>
                <span>HomeCare</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 4 ? "active" : ""}`} onClick={() => setIsActive(4)}>
              <span className="st-orange-box">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 480.335 480.335"
                  xmlSpace="preserve"
                >
                  <g>
                    <path
                      d="M341.311,0c-6.249,0.011-12.488,0.5-18.662,1.462c-14.488,2.469-28.449,7.393-41.28,14.56
                  c-25.694,13.956-56.706,13.956-82.4,0c-12.835-7.142-26.796-12.039-41.28-14.48C90.764-8.885,28.058,36.915,17.63,103.84
                  c-0.958,6.148-1.447,12.36-1.462,18.582v13.6c-0.142,22.285,5.925,44.169,17.52,63.2c30.684,49.633,50.202,105.349,57.2,163.28
                  l8.88,73.52c2.439,22.858,20.241,41.057,43.04,44c26.339,3.001,50.124-15.918,53.125-42.258c0.027-0.234,0.052-0.468,0.075-0.702
                  l16.72-156.16c1.639-15.155,15.253-26.111,30.408-24.472c12.894,1.394,23.078,11.578,24.472,24.472l16.72,155.92
                  c2.474,24.619,23.257,43.324,48,43.2h1.36c23.909,0.276,44.375-17.086,48-40.72l12.4-77.84c9.56-57.745,28.475-113.545,56-165.2
                  c9.255-17.588,14.087-37.166,14.08-57.04v-16.8C464.048,54.69,409.043-0.12,341.311,0z M448.169,139.222
                  c-0.046,17.675-4.442,35.066-12.8,50.64c-28.409,52.741-47.746,109.885-57.2,169.04l-12.48,77.92
                  c-2.393,15.777-16.043,27.38-32,27.2h-1.36c-16.523,0.079-30.389-12.435-32-28.88l-16.72-155.12
                  c-1.998-23.997-23.071-41.83-47.068-39.831c-20.83,1.735-37.499,18.008-39.732,38.791l-16.64,155.28
                  c-1.287,14.018-11.354,25.662-25.04,28.96c-17.185,4.123-34.459-6.466-38.582-23.652c-0.318-1.326-0.551-2.672-0.698-4.028
                  l-10.24-85.2c-7.763-56.732-27.566-111.148-58.08-159.6c-9.991-16.508-15.3-35.424-15.36-54.72v-13.6
                  C32.174,63.659,79.816,16.027,138.579,16.032c18.05,0.002,35.804,4.596,51.589,13.349c31.071,17.367,68.929,17.367,100,0v0.08
                  c51.39-28.498,116.153-9.94,144.651,41.45c8.741,15.762,13.334,33.486,13.349,51.51V139.222z"
                    />
                    <path
                      d="M308.089,65.062c-21.091,10.424-44.401,15.559-67.92,14.96c-23.572,0.625-46.941-4.51-68.08-14.96
                  c-3.845-2.158-8.711-0.798-10.88,3.04c-2.158,3.845-0.798,8.711,3.04,10.88c23.519,11.841,49.597,17.694,75.92,17.04
                  c26.323,0.654,52.401-5.199,75.92-17.04c3.844-2.209,5.169-7.116,2.96-10.96C316.84,64.178,311.933,62.853,308.089,65.062z"
                    />
                  </g>
                </svg>
                <span>Odontología</span>
              </span>
            </li>
            <li className={`st-tab-title ${isActive === 5 ? "active" : ""}`} onClick={() => setIsActive(5)}>
              <span className="st-gray-box">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  xmlSpace="preserve"
                >
                  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
                    <path d="M2307 5096 c-132 -36 -227 -172 -227 -327 l0 -46 -57 -13 c-32 -6
                    -110 -29 -173 -50 -688 -225 -1240 -775 -1463 -1458 -75 -229 -105 -397 -116
                    -646 l-6 -149 -43 -15 c-55 -18 -146 -102 -180 -166 -26 -49 -27 -57 -27 -206
                    0 -141 2 -159 23 -201 34 -70 84 -122 154 -160 l63 -34 541 -3 541 -3 6 -177
                    c10 -278 55 -441 170 -615 94 -140 180 -214 607 -522 217 -157 405 -288 417
                    -291 13 -3 33 -3 46 0 29 8 787 555 852 615 81 75 149 157 197 239 100 170
                    135 309 145 574 l6 177 541 3 541 3 63 34 c70 38 119 89 154 160 21 42 23 59
                    23 201 0 149 -1 157 -27 206 -34 64 -125 148 -180 166 l-43 15 -6 149 c-11
                    249 -41 417 -116 646 -52 159 -164 393 -253 528 -313 475 -785 820 -1318 963
                    l-122 32 0 45 c0 159 -103 300 -240 329 -72 15 -433 13 -493 -3z m489 -182
                    c15 -11 37 -33 48 -48 21 -27 21 -35 24 -1035 l2 -1008 -87 15 c-97 15 -427
                    11 -495 -6 l-38 -10 0 993 c0 680 3 1003 11 1022 6 15 20 39 32 52 43 47 68
                    51 279 48 181 -2 199 -4 224 -23z m-716 -1248 l0 -884 -107 -36 c-127 -44
                    -284 -115 -425 -192 -157 -85 -186 -104 -192 -119 -5 -13 -71 -15 -461 -15
                    l-455 0 0 93 c1 491 207 1015 550 1392 109 120 333 316 346 302 2 -2 25 -307
                    50 -678 51 -766 43 -724 129 -724 40 0 51 4 67 26 19 25 19 31 -26 715 -25
                    379 -47 709 -48 733 l-3 44 94 48 c112 58 275 122 391 154 47 13 86 24 88 24
                    1 1 2 -397 2 -883z m1247 793 c55 -22 143 -61 195 -88 l93 -48 -3 -44 c-1 -24
                    -23 -354 -48 -733 -45 -684 -45 -690 -26 -715 16 -22 27 -26 67 -26 86 0 78
                    -42 129 724 25 371 48 676 50 678 13 14 237 -182 346 -302 343 -377 549 -901
                    550 -1392 l0 -93 -455 0 c-393 0 -456 2 -461 15 -6 13 -72 53 -244 148 -98 53
                    -257 122 -375 163 l-105 36 0 884 0 883 93 -26 c50 -13 138 -43 194 -64z
                    m-646 -1780 c268 -27 521 -116 847 -297 l82 -46 0 -470 c0 -281 -4 -507 -11
                    -561 -26 -216 -121 -403 -272 -541 -64 -58 -750 -554 -767 -554 -17 0 -704
                    496 -768 555 -118 107 -209 260 -253 425 -22 82 -23 102 -27 616 l-4 530 94
                    52 c347 191 656 290 939 301 20 0 83 -4 140 -10z m-1341 -659 l0 -230 -509 0
                    c-336 0 -519 4 -538 11 -34 12 -80 55 -98 89 -20 39 -28 130 -16 194 13 72 49
                    121 105 147 38 17 74 19 549 19 l507 0 0 -230z m3496 211 c56 -26 92 -75 105
                    -147 12 -64 4 -155 -16 -194 -18 -34 -64 -77 -98 -89 -19 -7 -202 -11 -538
                    -11 l-509 0 0 230 0 230 508 0 c474 0 510 -2 548 -19z"/>
                    <path d="M2350 2555 c-109 -18 -231 -52 -349 -98 -110 -42 -324 -148 -353
                    -174 -17 -15 -18 -51 -18 -502 0 -522 3 -555 53 -678 35 -87 91 -168 167 -241
                    36 -35 202 -162 370 -283 258 -185 310 -219 340 -219 30 0 82 34 340 219 168
                    121 334 248 370 283 76 73 132 154 167 241 50 123 53 156 53 679 l0 487 -27
                    20 c-71 56 -371 187 -525 230 -184 50 -420 65 -588 36z m401 -171 c124 -21
                    299 -79 448 -150 l121 -57 0 -428 c0 -272 -4 -447 -11 -481 -17 -84 -74 -191
                    -135 -258 -36 -38 -160 -134 -335 -261 l-279 -200 -279 200 c-300 216 -369
                    279 -421 384 -59 120 -60 131 -60 608 l0 436 121 57 c144 68 323 129 439 149
                    114 20 276 21 391 1z"/>
                    <path d="M2895 2106 c-35 -18 -118 -94 -279 -255 l-229 -230 -74 94 c-84 107
                    -127 135 -211 135 -127 0 -214 -85 -215 -209 0 -35 7 -69 18 -91 26 -51 302
                    -397 339 -425 48 -37 115 -50 178 -35 52 12 62 22 396 354 196 194 352 358
                    364 380 31 60 23 161 -17 217 -60 84 -177 112 -270 65z m123 -158 c31 -31 10
                    -56 -311 -376 -177 -177 -327 -322 -333 -322 -19 0 -41 25 -178 197 -135 172
                    -157 213 -120 227 34 13 47 2 140 -116 53 -68 104 -129 112 -135 9 -7 34 -13
                    56 -13 39 0 47 6 316 275 151 151 282 275 291 275 8 0 20 -5 27 -12z"/>
                  </g>
                </svg>
                <span>SGSST</span>
              </span>
            </li>
          </ul>
          <div className="st-height-b25 st-height-lg-b25" />
          <div className="tab-content">
            <div id="Crutches" className={`st-tab ${isActive === 0 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/servicio_1.png" alt="service" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-imagebox-info">
                          <h2 className="st-imagebox-title">
                            Consulta Médica y <span>Especialidades Clínicas</span>
                          </h2>
                          <h4 className="st-imagebox-subtitle">
                            Atención integral en medicina general y especialidades clínicas.
                          </h4>
                          <div className="st-imagebox-text">
                            Ofrecemos atención médica especializada para el diagnóstico, tratamiento y seguimiento de múltiples patologías en adultos, niños y adolescentes. Contamos con un equipo interdisciplinario de profesionales altamente calificados en áreas como medicina interna, pediatría, psiquiatría, neurología, cardiología, gastroenterología, dermatología, oftalmología, entre otras. Nuestra infraestructura está equipada para consultas ambulatorias con tecnología diagnóstica complementaria que garantiza una atención precisa, oportuna y centrada en el paciente.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="X-ray" className={`st-tab ${isActive === 1 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/servicio_2.png" alt="service" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-vertical-middle-in">
                          <div className="st-imagebox-info">
                            <h2 className="st-imagebox-title">
                              Diagnóstico por Imágenes <span>(Radiología No Ionizante)</span>
                            </h2>
                            <h4 className="st-imagebox-subtitle">
                              Ecografías diagnósticas sin radiación, seguras y de alta calidad.
                            </h4>
                            <div className="st-imagebox-text">
                              Disponemos de un moderno servicio de imágenes diagnósticas basado en radiología no ionizante, enfocado en brindar estudios seguros, confiables y con alto nivel de detalle. Realizamos ecografías abdominales, ginecológicas, musculoesqueléticas, doppler vascular, mamarias y más, empleando equipos de última generación y personal técnico experto. Este servicio es clave para la evaluación temprana de condiciones clínicas sin exposición a radiación.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Pulmonary" className={`st-tab ${isActive === 2 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/servicio_3.png" alt="service" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-vertical-middle-in">
                          <div className="st-imagebox-info">
                            <h2 className="st-imagebox-title">
                              Terapias y <span>Rehabilitación Integral</span>
                            </h2>
                            <h4 className="st-imagebox-subtitle">
                              Recuperación funcional a través de terapias especializadas.
                            </h4>
                            <div className="st-imagebox-text">
                              Nuestro enfoque de rehabilitación está diseñado para acompañar a los usuarios en su recuperación física y funcional con un abordaje integral y personalizado. Prestamos servicios en fisioterapia, fonoaudiología, terapia ocupacional, terapia respiratoria, rehabilitación neurológica, vestibular y cardiopulmonar. Nos apoyamos en protocolos científicos, evaluación continua y programas específicos según la condición del paciente, promoviendo su autonomía y calidad de vida.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Cardiology" className={`st-tab ${isActive === 3 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/servicio_4.png" alt="service" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-vertical-middle-in">
                          <div className="st-imagebox-info">
                            <h2 className="st-imagebox-title">
                              Atención Domiciliaria <span>(Hospitalización en Casa)</span>
                            </h2>
                            <h4 className="st-imagebox-subtitle">
                              Cuidados médicos y terapéuticos en la comodidad del hogar.
                            </h4>
                            <div className="st-imagebox-text">
                              Llevamos el cuidado de la salud directamente al hogar de nuestros pacientes, con todos los estándares de seguridad y calidad clínica. Nuestro servicio de hospitalización domiciliaria permite continuar tratamientos médicos, terapias o cuidados especiales fuera del entorno hospitalario. Incluye visitas médicas, seguimiento de enfermería, toma de muestras, asesoría nutricional, manejo de heridas y terapias de recuperación en el entorno familiar, promoviendo una experiencia más humana, cómoda y efectiva.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="DentalCare" className={`st-tab ${isActive === 4 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/servicio_5.png" alt="service" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-vertical-middle-in">
                          <div className="st-imagebox-info">
                            <h2 className="st-imagebox-title">
                              Odontología General y <span>Especializada</span>
                            </h2>
                            <h4 className="st-imagebox-subtitle">
                              Cuidado oral integral para todas las edades.
                            </h4>
                            <div className="st-imagebox-text">
                              Ofrecemos servicios odontológicos para todas las edades, desde atención preventiva hasta procedimientos especializados. Nuestro equipo realiza tratamientos de odontología general, cirugía oral, ortodoncia, endodoncia y estética dental con tecnología avanzada, protocolos de bioseguridad estrictos y un enfoque centrado en la comodidad y confianza del paciente. Trabajamos para mantener y restaurar la salud bucal, contribuyendo a la calidad de vida y bienestar integral.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Neurology" className={`st-tab ${isActive === 5 ? "active" : ""}`}>
              <div className="st-imagebox st-style2">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="st-imagebox-img">
                      <img src="/images/servicio_6.png" alt="service" />
                    </div>
                    <div className="st-height-b0 st-height-lg-b30" />
                  </div>
                  <div className="col-lg-6">
                    <div className="st-vertical-middle">
                      <div className="st-vertical-middle-in">
                        <div className="st-vertical-middle-in">
                          <div className="st-imagebox-info">
                            <h2 className="st-imagebox-title">
                              Seguridad y Salud en el Trabajo <span>(SGSST)</span>
                            </h2>
                            <h4 className="st-imagebox-subtitle">
                              Programas de prevención, promoción y cumplimiento normativo.
                            </h4>
                            <div className="st-imagebox-text">
                              Diseñamos e implementamos programas de Seguridad y Salud en el Trabajo enfocados en la prevención de riesgos laborales, la promoción de entornos saludables y el cumplimiento de la normatividad vigente. Acompañamos a empresas en la estructuración de sistemas integrales, valoraciones médicas, actividades de promoción y prevención, capacitaciones y planes de intervención específicos. Nuestro objetivo es cuidar del talento humano y fortalecer la cultura organizacional desde la salud ocupacional.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="st-height-b120 st-height-lg-b80" />
    </section>
  );
};

export default Department;
